import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './Common.scss';

const TermsOfService: React.FC = () => {
  return (
    <div className="page-layout">
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg={10} md={12}>
            <Card className="shadow-sm">
              <Card.Header>
                <h1 className="mb-0">利用規約</h1>
              </Card.Header>
              <Card.Body>
                <div className="content-section">
                  <p className="mb-4">
                    この利用規約（以下「本規約」）は、ヒーリングサロン
                    軍陀利（以下「当サロン」）が提供するサービスの利用条件を定めるものです。本サービスをご利用になる場合には、本規約に同意いただいたものとみなします。
                  </p>

                  <h5>第1条（適用）</h5>
                  <ol>
                    <li>
                      本規約は、お客様と当サロンとの間のサービス利用に関わる一切の関係に適用されるものとします。
                    </li>
                    <li>
                      当サロンは本規約のほか、ご利用にあたってのルール等、各種の定め（以下「個別規定」）をすることがあります。これら個別規定はその名称のいかんに関わらず、本規約の一部を構成するものとします。
                    </li>
                    <li>
                      本規約の規定が前項の個別規定の規定と矛盾する場合には、個別規定において特段の定めなき限り個別規定の規定が優先されるものとします。
                    </li>
                  </ol>

                  <h5>第2条（利用登録）</h5>
                  <ol>
                    <li>
                      登録希望者が当サロンの定める方法によって利用登録を申請し、当サロンがこれを承認することによって、利用登録が完了するものとします。
                    </li>
                    <li>
                      当サロンは、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。
                      <ul>
                        <li>利用登録の申請に際して虚偽の事項を届け出た場合</li>
                        <li>
                          本規約に違反したことがある者からの申請である場合
                        </li>
                        <li>
                          その他、当サロンが利用登録を相当でないと判断した場合
                        </li>
                      </ul>
                    </li>
                  </ol>

                  <h5>第3条（サービス内容）</h5>
                  <ol>
                    <li>
                      当サロンは以下のサービスを提供します：
                      <ul>
                        <li>ヒーリングセッション（対面・遠隔）</li>
                        <li>クリスタルヒーリング</li>
                        <li>DNAアクティベーション</li>
                        <li>エンソフィックレイキ</li>
                        <li>ハンドメイドアクセサリーの販売（今後展開予定）</li>
                        <li>その他当サロンが提供するサービス</li>
                      </ul>
                    </li>
                    <li>
                      当サロンは、サービス内容を予告なく変更または終了する場合があります。
                    </li>
                  </ol>

                  <h5>第4条（利用料金および支払い）</h5>
                  <ol>
                    <li>
                      お客様は、当サロンが別途定める利用料金を、当サロンが指定する方法により支払うものとします。
                    </li>
                    <li>
                      支払いは、原則としてクレジットカード決済による事前決済とします。
                    </li>
                    <li>
                      お客様が利用料金の支払いを遅滞した場合には、お客様は年14.6％の割合による遅延損害金を支払うものとします。
                    </li>
                  </ol>

                  <h5>第5条（予約・キャンセル）</h5>
                  <ol>
                    <li>
                      ヒーリングセッションの予約は、当サロンが指定する方法により行うものとします。
                    </li>
                    <li>
                      キャンセルについては、以下の通りキャンセル料を申し受けます：
                      <ul>
                        <li>24時間前まで：無料</li>
                        <li>24時間以内：料金の50%</li>
                        <li>当日キャンセル：料金の100%</li>
                      </ul>
                    </li>
                    <li>
                      天災、疫病、交通機関の運休等、お客様の責によらない正当な理由がある場合は、上記キャンセル料は免除されます。
                    </li>
                  </ol>

                  <h5>第6条（禁止事項）</h5>
                  <p>
                    お客様は、本サービスの利用にあたり、以下の行為をしてはなりません。
                  </p>
                  <ol>
                    <li>法令または公序良俗に違反する行為</li>
                    <li>犯罪行為に関連する行為</li>
                    <li>
                      当サロンのサーバーまたはネットワークの機能を破壊したり、妨害したりする行為
                    </li>
                    <li>当サロンのサービスの運営を妨害するおそれのある行為</li>
                    <li>
                      他のお客様に関する個人情報等を収集または蓄積する行為
                    </li>
                    <li>他のお客様に成りすます行為</li>
                    <li>
                      当サロンのサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為
                    </li>
                    <li>宗教活動または宗教団体への勧誘行為</li>
                    <li>その他、当サロンが不適切と判断する行為</li>
                  </ol>

                  <h5>第7条（セッション時の注意事項）</h5>
                  <ol>
                    <li>
                      ヒーリングは医療行為ではありません。医療機関での診断・治療の代替となるものではありません。
                    </li>
                    <li>
                      現在医療機関で治療を受けている方は、必ず医師にご相談の上でセッションをお受けください。
                    </li>
                    <li>妊娠中の方、持病のある方は事前にお申し出ください。</li>
                    <li>
                      セッション中に体調不良を感じた場合は、すぐにお知らせください。
                    </li>
                    <li>
                      効果の現れ方や感じ方には個人差があることをご理解ください。
                    </li>
                    <li>
                      セッション後の好転反応（一時的な体調変化）が起こる場合があることをご了承ください。
                    </li>
                  </ol>

                  <h5>第8条（知的財産権）</h5>
                  <ol>
                    <li>
                      当サロンが提供するサービス、ウェブサイト、コンテンツ等に関する知的財産権は、当サロンに帰属します。
                    </li>
                    <li>
                      お客様は、当サロンが提供するコンテンツを、当サロンの事前の書面による同意なく、複製、転載、配布、販売等をしてはなりません。
                    </li>
                  </ol>

                  <h5>第9条（個人情報の保護）</h5>
                  <ol>
                    <li>
                      当サロンは、お客様の個人情報を適切に管理し、
                      <a
                        href="/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        プライバシーポリシー
                      </a>
                      に従って取り扱います。
                    </li>
                    <li>
                      セッションにおいて知り得たお客様の情報については、守秘義務を負います。
                    </li>
                  </ol>

                  <h5>第10条（免責事項）</h5>
                  <ol>
                    <li>
                      当サロンは、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。
                    </li>
                    <li>
                      当サロンは、本サービスに起因してお客様に生じたあらゆる損害について一切の責任を負いません。ただし、当サロンとお客様との間の契約が消費者契約法に定める消費者契約となる場合、この免責規定は適用されません。
                    </li>
                    <li>
                      前項ただし書に定める場合であっても、当サロンは、当サロンの過失（重過失を除きます。）による債務不履行または不法行為によりお客様に生じた損害のうち特別な事情から生じた損害（当サロンまたはお客様が損害発生につき予見し、または予見し得た場合を含みます。）について一切の責任を負いません。
                    </li>
                  </ol>

                  <h5>第11条（サービス内容の変更等）</h5>
                  <p>
                    当サロンは、お客様に通知することなく、本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし、これによってお客様に生じた損害について一切の責任を負いません。
                  </p>

                  <h5>第12条（利用規約の変更）</h5>
                  <p>
                    当サロンは、必要と判断した場合には、お客様に通知することなく本規約を変更することができるものとします。変更後の規約は、当ウェブサイトに掲載された時点から効力を生じるものとします。
                  </p>

                  <h5>第13条（個別規定）</h5>
                  <p>
                    本サービスの具体的な利用条件等は、本規約のほか、当サロンが別途定める個別規定によるものとします。
                  </p>

                  <h5>第14条（通知または連絡）</h5>
                  <p>
                    お客様と当サロンとの間の通知または連絡は、当サロンの定める方法によって行うものとします。当サロンは、お客様から、当サロンが別途定める方式に従った変更届け出がない限り、現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い、これらは、発信時にお客様へ到達したものとみなします。
                  </p>

                  <h5>第15条（権利義務の譲渡の禁止）</h5>
                  <p>
                    お客様は、当サロンの書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできません。
                  </p>

                  <h5>第16条（準拠法・裁判管轄）</h5>
                  <ol>
                    <li>本規約の解釈にあたっては、日本法を準拠法とします。</li>
                    <li>
                      本サービスに関して紛争が生じた場合には、当サロンの本店所在地を管轄する裁判所を専属的合意管轄とします。
                    </li>
                  </ol>

                  <p className="mt-4">
                    <strong>制定日：</strong> 2025年11月3日
                    <br />
                    <strong>最終更新日：</strong> 2025年11月3日
                    <br />
                    <strong>ヒーリングサロン Gundari</strong>
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TermsOfService;
